import React, {useState, useEffect, useMemo} from 'react';
import { Alert, Modal, ScrollView, Share, TouchableOpacity, View } from 'react-native'

import tw from '../../../../styles/tailwind';
import Text from '../../../../components/Text';
import IcomoonIcon from '../../../../components/IcomoonIcon';
import { Illustration } from '../../../../components/Illustration';
import { Icon } from '../../../../components/Icon';
import IconButton from '../../../../components/IconButton';
import BottomSheetModal from '../../../../components/BottomSheetModal';


import dayjs from 'dayjs'
import 'dayjs/locale/es'
import { useSafeAreaInsets } from 'react-native-safe-area-context';
import { Image } from 'expo-image';
import { Ionicons } from '@expo/vector-icons';
dayjs.locale('es')


function EventGuessRow({guestPass}){
  const [sent, setSent] = useState(false);

  async function sendGuestPass() {
    const message = guestPass.message
    const title = guestPass.title


    try {
      const result = await Share.share({
        message,
        title,
      }, {
        dialogTitle: "Comparte este pase",
      });
      if (result.action === Share.sharedAction) {
        setSent(true)
        if (result.activityType) {
          // shared with activity type of result.activityType
        } else {
          // shared
        }
      } else if (result.action === Share.dismissedAction) {
        // dismissed
      }
    } catch (error: any) {
      Alert.alert(error.message);
    }
  }

  return (
    <View style={tw`row`}>
      <View style={tw`bg-white rounded-lg border border-primary-200 px-5 py-3 flex-1 mr-1`}>
        <Text style={tw`text-primary-800 font-500`}>{guestPass.guest_name}</Text>
      </View>
      
      <TouchableOpacity
        style={tw`bg-primary-700 rounded-xl w-12 h-12 items-center justify-center`}
        onPress={sendGuestPass}
      >
        {
          ! sent ?
            <Icon name="qr" size={32} />
          :
            <Ionicons name='checkmark' color={'#fff'} size={24} />

        }
      </TouchableOpacity>
    </View>
  )
}


export default function EventPassesDetailModal({ onRequestClose, visible, guestPasses }) {
  const insets = useSafeAreaInsets()


  if (!guestPasses?.length) return null

  const guestPass = guestPasses[0]
  console.log({guestPass, a:123});

  const entryDate = dayjs(guestPass?.data?.entry_date)
  const entryTime = guestPass?.data?.entry_time == "all_day" ? guestPass?.data?.entry_time : dayjs(guestPass?.data?.entry_time)

  

  return (
    <Modal
      onRequestClose={onRequestClose}
      visible={visible}
      statusBarTranslucent={true}
      animationType='slide'
    >
      <View style={tw`flex-1  bg-primary pt-[${insets.top}px `}>
        {/* Header */}
        <View style={tw`row justify-between mb-4 mt-5 px-5`}>
          <View style={tw`row`}>
            <Icon name="qr" size={40} style={tw`mr-3`} />

            <Text style={tw`text-lg font-600 text-secondary`}>Nuevo QR de invitado</Text>
          </View>

          <TouchableOpacity
            style={tw`items-center justify-center mr-2`}
            onPress={onRequestClose}
          >
            <IcomoonIcon name='close' style={tw`text-red`} size={26} />
          </TouchableOpacity>
        </View>

        <ScrollView style={tw`px-5 flex-1`} contentContainerStyle={tw`pb-10`}>


          {/* Instrucciones */}
          <Text style={tw`text-white text-center text-lg font-500 mb-4 mt-6 px-4`}>Envía la invitación por mensaje a todos tus invitados para permitirles el acceso</Text>

          <View style={tw`row justify-center mb-8`}>
            <Text style={tw`text-white text-center text-lg font-500`}>Pulsa</Text>

            <Icon name="qr" size={32} />

            <Text style={tw`text-white text-center text-lg font-500`}>para enviar</Text>
          </View>


          <View style={tw`bg-primary-100 border border-gray-200 px-3 py-6 rounded-xl items-center mb-12`}>
            <Text style={tw`px-3 text-lg font-500 text-primary-800 text-center mb-3`}>Invitación creada</Text>

            <Text style={tw`text-gray-400 text-lg text-red-500 mb-5`}>Reunión {entryDate.format('ddd D MMM YYYY')}</Text>

            <View style={tw`w-full gap-y-3`}>
              {
                guestPasses.map(pass => 
                  <EventGuessRow key={pass.uuid} guestPass={pass} />
                )
              }
            </View>
          </View>

          {/* <Text>{JSON.stringify(guestPass)}</Text> */}
          <IconButton
            title={"Terminar"}
            style={tw`py-4 w-80% self-center`}
            color='secondary'
            icon={null}
            onPress={onRequestClose}
          />
        </ScrollView>
      </View>
    </Modal>
  );
}
